module.exports = __webpack_public_path__ + "static/media/Cross.829bd65b.svg";